<section class="employee-view" id="content" *ngIf="this.lang">
  <div class="page page-profile">

    <!-- page header -->
    <div class="pageheader">
      <h2>{{lang?.emp_view}}</h2>
      <div class="page-bar">
        <ul class="page-breadcrumb">
          <li>
            <a [routerLink]="'/'+AppFrontRoutes.DASHBOARD"><i class="fa fa-home"></i>
              {{AppSettings.SITE_TITLE | titlecase}}</a>
          </li>
          <li>
            <a [routerLink]="'/'+AppFrontRoutes.EMPLOYEE_LIST">{{lang?.emp_view}}</a>
          </li>
          <li>
            <span *ngIf="this.emp">{{ emp.employee_name }} {{ emp.employee_surname }}</span>
          </li>

        </ul>

        <div style="float: right;">
          <div class="social-icons">
            <a class="plus-vdead" (click)="viewEmployee()"
              [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'">
              <i class="fa fa-list"></i>
            </a>
            <!-- 
            <a class="plus-edit" (click)="editServicing(this.id)"
              [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'">
              <i class="fa fa-edit"></i>
            </a> -->
          </div>
        </div>

      </div>
    </div>
    <!-- page content -->
    <div class="pagecontent">

      <!-- row -->
      <div class="row">
        <div class="col-md-12">
          <div class="tile tile-simple">

            <!-- tile body -->
            <div class="tile-body" [ngSwitch]="pageView">
              <div role="tabpanel" *ngSwitchCase="'list'">

                <!-- Nav tabs -->
                <ul class="nav nav-tabs tabs-dark" role="tablist">
                  <li role="presentation" class="active"><a href="#generalTab" aria-controls="feedTab" role="tab"
                    data-toggle="tab">{{lang?.personal_data}}</a></li>

                    <li role="presentation"><a href="#documentsTab" aria-controls="feedTab" role="tab"
                      data-toggle="tab">{{lang?.docs}}</a></li>

                      
                  <li role="presentation"><a href="#training" aria-controls="training" role="tab"
                      data-toggle="tab">{{lang?.training}}</a>
                  </li>

                  <li role="presentation"><a href="#dpi" aria-controls="dpi" role="tab" data-toggle="tab">Dpi</a></li>


                  <li role="presentation"><a href="#medical" aria-controls="medical" role="tab"
                      data-toggle="tab">{{lang?.medical_examination}}</a></li>

                  <li role="presentation"><a href="#notification" aria-controls="notification" role="tab"
                      data-toggle="tab">{{lang?.notification}}</a></li>
                </ul>


                <div class="tab-content">

                  <div role="tabpanel" class="tab-pane active" id="generalTab">
                    <div class="wrap-reset">

                     

                        <div class="row">
                          <form class="form-validation">

                          <div class="form-group col-sm-6" *ngIf="this.emp">

                            <div class="col-md-3"><img src="{{ emp.emp_image }}"
                                style="width: 100%;
                                  background-color: #f5f5f5;border: 1px solid #ddd; border-radius: 4px;display: block; line-height: 1.42857; margin-bottom: 20px; padding: 4px;transition: all 0.2s ease-in-out 0s;">
                            </div>

                            <div class="col-sm-9">
                              <div class="col-sm-3 for_label">{{lang?.name}}:</div>
                              <div class="col-sm-9 for_label_value">{{ emp.employee_name }}</div>

                              <div class="col-sm-3 for_label">{{lang?.surname}}:</div>
                              <div class="col-sm-9 for_label_value">{{ emp.employee_surname }}</div>

                              <div class="col-sm-3 for_label">{{lang?.email}}:</div>
                              <div class="col-sm-9 for_label_value">{{ emp.employee_email }}</div>

                              <div class="col-sm-3 for_label">{{lang?.status}}:</div>
                              <div class="col-sm-9 for_label_value">{{ emp.employee_state }}</div>
                            </div>

                            <div id="generalChart" #generalChart></div>

                          </div> 

                          <!-- <a id="imgQRD" href="" download="KaizenCloud_qrcode.jpg"></a> -->
                          <div class="form-group col-sm-6">

                            <label for="address">{{lang?.address}}</label>
                            <input type="text" class="form-control" [value]="emp?.employee_address" readonly>

                            <label for="phone">{{lang?.phone}}</label>
                            <input type="text" class="form-control" [value]="emp?.employee_phone" readonly>

                            <label for="tax_code">{{lang?.taxCode}}</label>
                            <input type="text" class="form-control" [value]="emp?.employee_tax_code" readonly>

                            <label for="place-of-use">{{lang?.dateofBirth}}</label>
                            <input type="text" class="form-control" [value]="emp?.emp_dob" readonly>

                            <label for="state">{{lang?.placeofBirth}}</label>
                            <input type="text" class="form-control" [value]="emp?.employee_placeOfbirth" readonly>

                            <label for="responsible">{{lang?.task}}</label>
                            <input type="text" class="form-control" [value]="emp?.employee_task" readonly>

                            <label for="qualifications">{{lang?.qualifications}}</label>
                            <input type="text" class="form-control" [value]="emp?.employee_qualification" readonly>

                            <label for="titleofstudy">{{lang?.titleofStudy}}</label>
                            <input type="text" class="form-control" [value]="emp?.employee_timeOfstudy" readonly>


                            <label for="assumptiondate">{{lang?.assumptionDate}}</label>
                            <input type="text" class="form-control" [value]="emp?.emp_assumption_date" readonly>

                            <label for="hourlycost">{{lang?.hourlyCost}}</label>
                            <input type="text" class="form-control" [value]="emp?.employee_houly_cost" readonly>

                   
                          </div>
                        </form>
                        </div>
                    </div>
                  </div>

                 <div role="tabpanel" class="tab-pane" id="documentsTab">
                    <div class="wrap-reset">
                        <div class="row" *ngIf="isApiLoaded == true">
                          <div class="form-group col-sm-12">

                            <form [formGroup]="createForm" class="form-validation" (ngSubmit)="certification_save()"
                            *ngIf="this.lang">
                            <div class="form-group row">
                            
                              <div class="form-group col-sm-6" formArrayName="attachment">
                                <label for="attachments">{{lang?.curriculum}}</label>
                                <div id="curriculum_val">
                                <div class="form-group row" *ngFor="let link of attachment().controls; let i = index;"
                                  [formGroupName]="i">
                                  <input type="file" class="filestyle" data-buttonText="Choose file"
                                    (change)="selectAttachment($event,i)" formControlName="link">
                                  <div id="cerr"></div>
                                </div>
                              </div>

                                <div style="display: none;" id="curriculum_edit">
                                  <span id="curriculum_edata"></span>
                                  <a href="javascript:void(0);" class="pull-right common-newicons icon-colors1 certification_edit">
                                    <span class="glyphicon glyphicon-edit" (click)="fileshow()"></span>
                                  </a>
                                </div>

                              </div>

                            
                              <input type="hidden" class="form-control" formControlName="ref_id">
                              <input type="hidden" class="form-control" formControlName="emp_id">
                            
                              <div class="col-sm-2">
                                <label for="expiry_date">{{lang?.expiry_date}}</label>
                                <input type="date" class="form-control" formControlName="expiry">
                                <div id="ceerr"></div>


                            
                            
                              </div>
                              <div class="col-sm-4">
                                  <div class="social-icons employee-action">
                                    <a class="employee-checkbox">
                                    <input type="checkbox" class="custom_checkbox1" formControlName="option"
                                    style="float: right">
                                    </a>
                                    <a class="plus-vdead certification_save" (click)="certification_save('curriculum')">
                                      <span class="glyphicon glyphicon-floppy-disk"></span>
                                    </a>
                                    <a class="delete_action certification_del"
                                      (click)="certification_del(this.id,this.cid)">
                                      <span class="glyphicon glyphicon-trash"></span>
                                    </a>
  
                                  </div>                                  
                              </div>
                            </div>
                            </form>

                            <form [formGroup]="createForm2" class="form-validation" (ngSubmit)="certification_save2()"
                            *ngIf="this.lang">
                            <div class="form-group row">
                            
                              <div class="form-group col-sm-6" formArrayName="attachment2">
                                <label for="attachments">{{lang?.identity_pappers}}</label>
                                <div id="identity_papers_val">
                                <div class="form-group row" *ngFor="let link of attachment2().controls; let i = index;"
                                  [formGroupName]="i">
                                  <input type="file" class="filestyle" data-buttonText="Choose file"
                                    (change)="selectAttachment2($event,i)" formControlName="link">
                                  <div id="iderr"></div>
                                </div>
                              </div>

                                <div style="display: none;" id="identity_papers_edit">
                                  <span id="identity_papers_edata"></span>
                                  <a href="javascript:void(0);" class="pull-right common-newicons icon-colors1 identity_papers_edit">
                                    <span class="glyphicon glyphicon-edit" (click)="fileshow2()"></span>
                                  </a>
                                </div>

                              </div>

                            
                              <input type="hidden" class="form-control" formControlName="ref_id">
                              <input type="hidden" class="form-control" formControlName="emp_id">
                            
                              <div class="col-sm-2">
                                <label for="expiry_date">{{lang?.expiry_date}}</label>
                                <input type="date" class="form-control" formControlName="expiry" value="">
                                <div id="ideerr"></div>


                            
                            
                              </div>
                              <div class="col-sm-4">
                                  <div class="social-icons employee-action">
                                    <a class="employee-checkbox">
                                      <input type="checkbox" class="custom_checkbox1" formControlName="option"
                                  style="float: right">
                                    </a>
                                    <a class="plus-vdead certification_save" (click)="certification_save2('identity')">
                                      <span class="glyphicon glyphicon-floppy-disk"></span>
                                    </a>
                              
                                    <a class="delete_action certification_del"
                                      (click)="certification_del2(this.id,this.identityid)">
                                      <span class="glyphicon glyphicon-trash"></span>
                                    </a>
  
                                  </div>                              
                                </div>
                            </div>
                            </form>
                           

                            <form [formGroup]="createForm3" class="form-validation" (ngSubmit)="certification_save3()"
                            *ngIf="this.lang">
                            <div class="form-group row">
                            
                              <div class="form-group col-sm-6" formArrayName="attachment3">
                                <label for="attachments">{{lang?.driver_license}}</label>
                                <div id="drivers_license_val">
                                <div class="form-group row" *ngFor="let link of attachment3().controls; let i = index;"
                                  [formGroupName]="i">
                                  <input type="file" class="filestyle" data-buttonText="Choose file"
                                    (change)="selectAttachment3($event,i)" formControlName="link">
                                  <div id="dlerr"></div>
                                </div>
                              </div>

                                <div style="display: none;" id="drivers_license_edit">
                                  <span id="drivers_license_edata"></span>
                                  <a href="javascript:void(0);" class="pull-right common-newicons icon-colors1 drivers_license_edit">
                                    <span class="glyphicon glyphicon-edit" (click)="fileshow3()"></span>
                                  </a>
                                </div>

                              </div>

                            
                              <input type="hidden" class="form-control" formControlName="ref_id">
                              <input type="hidden" class="form-control" formControlName="emp_id">
                            
                              <div class="col-sm-2">
                                <label for="expiry_date">{{lang?.expiry_date}}</label>
                                <input type="date" class="form-control" formControlName="expiry">
                                <div id="dleerr"></div>

                            
                            
                              </div>
                              <div class="col-sm-4">
                                

                                  <div class="social-icons employee-action">
                                    <a class="employee-checkbox">
                                      <input type="checkbox" class="custom_checkbox1" formControlName="option" 
                                      style="float: right">                                      
                                    </a>
                                    <a class="plus-vdead certification_save" (click)="certification_save3('drivers')">
                                      <span class="glyphicon glyphicon-floppy-disk"></span>
                                    </a>
                              
                                    <a class="delete_action certification_del"
                                      (click)="certification_del3(this.id,this.did)">
                                      <span class="glyphicon glyphicon-trash"></span>
                                    </a>
  
                                  </div>                                  
                              </div>
                            </div>
                            </form>


                            <form [formGroup]="createForm4" class="form-validation" (ngSubmit)="certification_save4()" *ngIf="this.lang">
                            <div class="form-group row">
                            
                              <div class="form-group col-sm-6" formArrayName="attachment4">
                                <label for="attachments">{{lang?.contract}}</label>
                                <div id="contract_val">
                            <div class="form-group row" *ngFor="let link4 of attachment4().controls; let i = index;" [formGroupName]="i">
                                  <input type="file" class="filestyle" data-buttonText="Choose file"
                                    (change)="selectAttachment4($event,i)" formControlName="link4">
                                  <div id="con_err"></div>
                                </div>
                              </div>

                                <div style="display: none;" id="contract_edit">
                                  <span id="contract_edata"></span>
                                  <a href="javascript:void(0);" class="pull-right common-newicons icon-colors1 contract_edit">
                                    <span class="glyphicon glyphicon-edit" (click)="fileshow4()"></span>
                                  </a>
                                </div>

                              </div>

                            
                              <input type="hidden" class="form-control" formControlName="ref_id">
                              <input type="hidden" class="form-control" formControlName="emp_id">
                            
                              <div class="col-sm-2">
                                <label for="expiry_date">{{lang?.expiry_date}}</label>
                                <input type="date" class="form-control" formControlName="expiry">
                                <div id="con_eerr"></div>


                            
                            
                              </div>
                              <div class="col-sm-4">
                                
                                <div class="social-icons employee-action">
                                  <a class="employee-checkbox">
                                    <input type="checkbox" class="custom_checkbox1" formControlName="option" >
                                  </a>
                                  <a class="plus-vdead certification_save4" (click)="certification_save4('contract')">
                                    <span class="glyphicon glyphicon-floppy-disk"></span>
                                  </a>
                            
                                  <a class="delete_action certification_del"
                                    (click)="certification_del4(this.id,this.conid)">
                                    <span class="glyphicon glyphicon-trash"></span>
                                  </a>
                                </div>                                
                              </div>
                            </div>
                            </form>
                            
                                                 
                        </div>
                      </div>
                    </div>
                  </div>

                   <div role="tabpanel" class="tab-pane" id="training">
                    <div class="row p-10">
                      <div class="col-sm-3">
                        <div class="social-icons">
                          <a class="plus-export" data-toggle="modal" data-target="#datatableExport1"
                            data-options="splash-2 splash-ef-4">
                            <span class="glyphicon glyphicon-export"></span>
                          </a>
                        </div>
                      </div>

                      <div  class="col-sm-9">
                        <input
                        style="float: right;width: 20%;"
                        #search
                        id="trainingSearch"
                        type="text"
                        class="form-control"
                        placeholder="Search"
                        aria-label="Search"
                        aria-describedby="basic-addon1"
                      />                        
                      </div>                         
                    </div>

                    <div class="form-group" style="overflow: auto;">
                      <table datatable [dtOptions]="datatableOptions1" class="table-striped table-sm row-border hover"
                        id="table1" *ngIf="training">
                        <thead>
                          <tr>
                            <th>Hidden.No</th>
                            <th>
                              <label class="checkbox checkbox-custom-alt checkbox-custom-sm">
                                <input type="checkbox"><i></i>
                              </label>
                            </th>
                            <th>{{ lang?.sno }}</th>
                            <th>{{ lang?.courseCode }}</th>
                            <th>{{ lang?.courseAttended }}</th>
                            <th>{{ lang?.type }}</th>
                            <th>{{ lang?.durationHours }}</th>
                            <th>{{ lang?.startDate }}</th>
                            <th>{{ lang?.endDate }}</th>
                            <th>{{ lang?.teacher }}</th>
                            <th>{{ lang?.outcome }}</th>
                            <th>{{ lang?.certificate }}</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let tvalue of training let k = index" id="{{ tvalue.course_code }}">
                            <td>{{k+1}}</td>
                            <td></td>
                            <td>{{k+1}}</td>
                            <td>{{ tvalue.course_code }}</td>
                            <td>{{ tvalue.course_name }}</td>
                            <td>ss</td>
                            <td>{{ tvalue.course_hours }}</td>
                            <td>{{ tvalue.course_start_date }}</td>
                            <td>{{ tvalue.course_end_date }}</td>
                            <td>{{ tvalue.teacher }}</td>
                            <td>{{ tvalue.option }}</td>
                            <td><button class="btn btn-purple" data-toggle="modal" data-target="#uploadcertificate" data-action="show">{{ lang?.uploadCertificate }}</button></td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                  </div>

                  <div role="tabpanel" class="tab-pane" id="dpi">

                    <div class="row p-12">
                      <div class="col-sm-6">
                        <div class="panel panel-default">
                          <div class="panel-heading">{{ lang?.list_of_delivery_report }}
                            <a class="btn btn-purple pull-right " (click)="addDeliveryreport()"
                              style="margin-top: -8px;"><i class="fa fa-plus fa-fw"></i>{{lang?.add_delivery_report}}</a>
                          </div><br>
                          <div class="panel-body">

                            <div class="social-icons">
                              <a class="plus-export" data-toggle="modal" data-target="#datatableExport2"
                                data-options="splash-2 splash-ef-4">
                                <span class="glyphicon glyphicon-export"></span>
                              </a>
                            </div>


                            <div class="form-group" style="overflow: auto;">
                              <table datatable="ng" [dtOptions]="datatableOptions2"
                                class="table-striped table-sm row-border hover" id="table2" *ngIf="first1">
                                <thead>
                                  <tr>
                                    <th>{{lang?.description}}</th>
                                    <th>{{lang?.date}}</th>
                                    <th>{{lang?.notes}}</th>
                                    <th>{{lang?.attachments}}</th>
                                    <th>{{lang?.action}}</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr *ngFor="let fvalue of first1" id="{{ fvalue.id }}">
                                    <td>{{ fvalue.disp }}</td>
                                    <td>{{ fvalue.delivery_date }}</td>
                                    <td>{{ fvalue.note }}</td>
                                    <td>{{ fvalue.attachment }}</td>
                                    <td>
                                      <div class="btn-group dropup">

                                        <button type="button" class="btn btn-info dropdown-toggle circle_btn"
                                          data-toggle="dropdown" aria-expanded="false"><i
                                            class="fa fa-tasks"></i></button>

                                        <ul class="dropdown-menu dropdown-menu-right action_btn" role="menu">
                                          <li [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'"><a
                                              class="blue_action" (click)="delete(fvalue.id)"><i
                                                class="fa fa-trash"></i> {{lang?.erase}}</a></li>
                                          <li [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'"><a
                                              class="edit_action" (click)="editEmployee(fvalue.id)"><i
                                                class="fa fa-edit"></i> {{lang?.modify}}</a></li>
                                          <li><a (click)="sendMail(fvalue.disp,fvalue.id)" class="blue_action"><i
                                                class="glyphicon glyphicon-eye-open"></i> {{lang?.email}}</a>
                                          </li>
                                        </ul>
                                      </div>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>


                      </div>

                      <div class="col-sm-6">
                        <div class="panel panel-default">
                          <div class="panel-heading">{{lang?.first_second_category}}
                            <a class="btn btn-purple pull-right " (click)="addDpi()" style="margin-top: -8px;"><i
                                class="fa fa-plus fa-fw"></i>{{lang?.add_dpi}}</a>
                          </div><br>
                          <div class="panel-body">

                            <div class="social-icons">
                              <a class="plus-export" data-toggle="modal" data-target="#datatableExport3"
                                data-options="splash-2 splash-ef-4">
                                <span class="glyphicon glyphicon-export"></span>
                              </a>
                            </div>


                            <div class="form-group" style="overflow: auto;">
                              <table datatable [dtOptions]="datatableOptions3"
                                class="table-striped table-sm row-border hover" id="table3" *ngIf="tab2seconddpi">
                                <thead>
                                  <tr>
                                    <th>{{lang?.device_name}}</th>
                                    <th>{{lang?.date_assignment}}</th>
                                    <th>{{lang?.type}}</th>
                                    <th>{{lang?.part_of_body}}</th>
                                    <th>{{lang?.attachemnts}}</th>
                                    <th>{{lang?.action}}</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr *ngFor="let fdvalue of tab2seconddpi let k = index" id="{{ fdvalue.id }}">
                                    <td>{{ fdvalue.sdisp }}</td>
                                    <td>{{ fdvalue.sdate }}</td>
                                    <td>{{ fdvalue.service_type }}</td>
                                    <td>{{ fdvalue.service_no_plate }}</td>
                                    <td><img src="{{fdvalue.sattach}}" style="width: 50px; height: 50px;"></td>
                                    <td>
                                      <div class="btn-group dropup">

                                        <button type="button" class="btn btn-info dropdown-toggle circle_btn"
                                          data-toggle="dropdown" aria-expanded="false"><i
                                            class="fa fa-tasks"></i></button>

                                        <ul class="dropdown-menu dropdown-menu-right action_btn" role="menu">

                                          <li [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'"><a
                                              class="blue_action" (click)="deletesdpi(fdvalue.id,this.id)"><i
                                                class="fa fa-trash"></i> {{lang?.erase}}</a></li>

                                          <li [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'"><a
                                              class="edit_action" (click)="editDpi(fdvalue.id)"><i
                                                class="fa fa-edit"></i> {{lang?.modify}}</a></li>

                                        </ul>
                                      </div>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>


                          </div>
                        </div>


                      </div>

                    </div>


                    <div class="row p-12">
                      <div class="col-sm-6">
                      </div>

                      <div class="col-sm-6">
                        <div class="panel panel-default">
                          <div class="panel-heading">{{ lang?.thirdCatergory }}
                            <a class="btn btn-purple pull-right " (click)="addDpithird(this.id)"
                              style="margin-top: -8px;"><i class="fa fa-plus fa-fw"></i>{{ lang?.addDpi }}</a>
                          </div><br>
                          <div class="panel-body">

                            <div class="social-icons">
                              <a class="plus-export" data-toggle="modal" data-target="#datatableExport4"
                                data-options="splash-2 splash-ef-4">
                                <span class="glyphicon glyphicon-export"></span>
                              </a>
                            </div>


                            <div class="form-group" style="overflow: auto;">
                              <table datatable [dtOptions]="datatableOptions4"
                                class="table-striped table-sm row-border hover" id="table4" *ngIf="device">
                                <thead>
                                  <tr>
                                    <th>{{ lang?.deviceName }}</th>
                                    <th>{{ lang?.brand }}</th>
                                    <th>{{ lang?.model }}</th>
                                    <th>{{ lang?.partofthebodyprotected}}</th>
                                    <th>{{ lang?.dateAssignment }}</th>
                                    <th>{{ lang?.action }}</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr *ngFor="let fdvalue of device let k = index" id="{{ fdvalue.id }}">

                                    <td>{{ fdvalue.service_disp }}</td>
                                    <td>{{ fdvalue.service_brand }}</td>
                                    <td>{{ fdvalue.service_model }}</td>
                                    <td>{{ fdvalue.part_of_the_body }}</td>
                                    <td>{{ fdvalue.service_date1 }}</td>
                                    <td>
                                      <div class="btn-group dropup">

                                        <button type="button" class="btn btn-info dropdown-toggle circle_btn"
                                          data-toggle="dropdown" aria-expanded="false"><i
                                            class="fa fa-tasks"></i></button>

                                        <ul class="dropdown-menu dropdown-menu-right action_btn" role="menu">

                                          <li [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'"><a
                                              class="blue_action" (click)="deletesdpi(fdvalue.id,fdvalue.emp_id,fdvalue.service_id)"><i
                                                class="fa fa-trash"></i> {{ lang?.erase }}</a></li>

                                          <li [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'">
                                            <a class="edit_action" (click)="editDpithird(fdvalue.id)"><i
                                                class="fa fa-edit"></i> {{ lang?.modify }}</a></li>

                                        </ul>
                                      </div>
                                    </td>

                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>


                      </div>

                    </div>



                  </div>

                  <div role="tabpanel" class="tab-pane" id="medical">

                    <div class="row p-10">

                      <div class="col-sm-3">
                        <div class="social-icons">
                          <a class="plus-export" data-toggle="modal" data-target="#datatableExport5"
                            data-options="splash-2 splash-ef-4">
                            <span class="glyphicon glyphicon-export"></span>
                          </a>
                        </div>
                      </div>

                      <div  class="col-sm-9">
                        <input
                        style="float: right;width: 20%;"
                        #search
                        id="medicalSearch"
                        type="text"
                        class="form-control"
                        placeholder="Search"
                        aria-label="Search"
                        aria-describedby="basic-addon1"
                      />                        
                      </div>                        
                    </div>

                    <div class="form-group" style="overflow: auto;">
                      <table datatable [dtOptions]="datatableOptions5" class="table-striped table-sm row-border hover"
                        id="table5" *ngIf="medicalData">
                        <thead>
                          <tr>
                            <th>Hidden.No</th>
                            <th>
                              <label class="checkbox checkbox-custom-alt checkbox-custom-sm">
                                <input type="checkbox"><i></i>
                              </label>
                            </th>
                            <th>{{ lang?.description }}</th>
                            <th>{{ lang?.exam_date }}</th>
                            <th>{{ lang?.outcome }}</th>
                            <th>{{ lang?.notes }}</th>
                            <th>{{ lang?.cost }}</th>
                            <th>{{ lang?.attachments }}</th>
                            <th>{{ lang?.action }}</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let medicalval of medicalData let k = index"
                            id="{{ medicalval.intervention_id }}">
                            <td>{{ k + 1 }}</td>
                            <td></td>
                            <td>{{ medicalval.description }}</td>
                            <td>{{ medicalval.exam_date }}</td>
                            <td><div *ngIf="!medicalval.outcome">{{ medicalval.outcome | nl2br }}</div></td>
                            <td><div *ngIf="!medicalval.notes">{{ medicalval.notes | nl2br }}</div></td>
                            <td><div *ngIf="!medicalval.cost">{{ medicalval.cost | nl2br }}</div></td>
                            <td>{{ medicalval.attachemnts }}</td>
                            <td>
                              <div class="btn-group dropup">

                                <button type="button" class="btn btn-info dropdown-toggle circle_btn"
                                  data-toggle="dropdown" aria-expanded="false"><i class="fa fa-tasks"></i></button>

                                <ul class="dropdown-menu dropdown-menu-right action_btn" role="menu">
                                  <li><a
                                      [routerLink]="['/'+AppFrontRoutes.NOTIFICATION_VIEW+'/'+medicalval.intervention_id]"
                                      class="view_action"><i class="glyphicon glyphicon-eye-open"></i> View</a>
                                  </li>

                                </ul>
                              </div>
                            </td>
                          </tr>


                        </tbody>

                      </table>
                    </div>


                  </div>


                  <div role="tabpanel" class="tab-pane" id="notification">

                    <div class="row p-10">
                      <div class="col-sm-3">
                        <div class="social-icons">
                          <a class="plus-export" data-toggle="modal" data-target="#datatableExport6"
                            data-options="splash-2 splash-ef-4">
                            <span class="glyphicon glyphicon-export"></span>
                          </a>
                        </div>
                      </div>
                      <div  class="col-sm-9">
                        <input
                        style="float: right;width: 20%;"
                        #search
                        id="notificationSearch"
                        type="text"
                        class="form-control"
                        placeholder="Search"
                        aria-label="Search"
                        aria-describedby="basic-addon1"
                      />                        
                      </div>  
                    </div>

                    <div class="form-group" style="overflow: auto;">
                      <table datatable [dtOptions]="datatableOptions6" class="table-striped table-sm row-border hover"
                        id="table6">
                        <thead>
                          <tr>
                            <th>Hidden.No</th>
                            <th>
                              <label class="checkbox checkbox-custom-alt checkbox-custom-sm">
                                <input type="checkbox"><i></i>
                              </label>
                            </th>
                            <th>{{ lang?.sno}}</th>
                            <th>{{ lang?.subject}}</th>
                            <th>{{ lang?.text }}</th>
                            <th>{{ lang?.date }}</th>
                            <th>{{ lang?.action }}</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let notify of notifi let k = index" id="{{ notify.id }}">
                            <td>{{ k + 1 }}</td>
                            <td></td>
                            <td>{{ k + 1 }}</td>
                            <td>{{ notify.subject }}</td>
                            <td>{{ notify.disp }}</td>
                            <td>{{ notify.noti_date }}</td>
                            <td>
                              <div class="btn-group dropup">

                                <button type="button" class="btn btn-info dropdown-toggle circle_btn"
                                  data-toggle="dropdown" aria-expanded="false"><i class="fa fa-tasks"></i></button>

                                <ul class="dropdown-menu dropdown-menu-right action_btn" role="menu">
                                  <li><a [routerLink]="['/'+AppFrontRoutes.NOTIFICATION_VIEW+'/'+notify.id]"
                                      class="view_action"><i class="glyphicon glyphicon-eye-open"></i> View</a>
                                  </li>

                                </ul>
                              </div>
                            </td>
                          </tr>


                        </tbody>

                      </table>
                    </div>

                  </div> 


                </div>
              </div>
            </div>

          </div>
        </div>
      </div>

    </div>
  </div>
</section>

<!-- <div class="modal splash fade" id="sactivate_plan" tabindex="-1" role="dialog" aria-hidden="true">

  <div class="modal-dialog">
    <div class="modal-content">

      <div class="modal-header">
        <h3 class="modal-title custom-font">{{ lang?.enterStartdate }}</h3>
      </div>

      <form #user="ngForm" (ngSubmit)="onSubmit(user.value)">
        <div class="modal-body column_export">
          <input type="date" class="form-control" name="date" id="date" value="" ngModel required>
          <input type="hidden" name="plan_id_forcd" id="plan_id_forcd" ngModel>
          <input type="hidden" name="pservice_id" id="pservice_id" ngModel>
        </div>

        <div class="modal-footer">
          <div id="datatableExportBtn1" class="export_dynamic_btn">
          </div>
          <button class="btn btn-success">{{ lang?.submit }}</button>
          <button class="btn btn-warning" data-dismiss="modal">{{ lang?.close }}</button>
        </div>
      </form>

    </div>
  </div>
</div> -->

<div class="modal splash fade" id="datatableExport1" tabindex="-1" role="dialog" aria-hidden="true">

  <div class="modal-dialog">
    <div class="modal-content">

      <div class="modal-header">
        <h3 class="modal-title custom-font">Select Columns</h3>
      </div>

      <div class="modal-body column_export">
        <div class="row select-alls">
          <label class="checkbox checkbox-custom-alt checkbox-custom-sm"> <input type="checkbox"
              (change)="export1_select_deselect_all($event)"><i></i> Select All </label>
        </div>
        <div class="row flexs">

          <div class="active-left">
            <h2>Active Columns</h2>

            <div class="row" *ngFor="let option of datatableCols1">
              <label class="checkbox checkbox-custom-alt checkbox-custom-sm">
                <input type="checkbox" value="{{option.id}}" [checked]="option.isSelected" class="col_select1"
                  (change)="export1_select_deselect($event)"><i></i> {{option.value}}
              </label>
            </div>

          </div>

        </div>

      </div>

      <div class="modal-footer">
        <div id="datatableExportBtn1" class="export_dynamic_btn">
        </div>
        <button class="btn btn-warning" data-dismiss="modal">Close</button>
      </div>

    </div>
  </div>
</div>
<div class="modal splash fade" id="uploadcertificate" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">

      <!-- <div class="modal-header">
          <h3 class="modal-title custom-font">IMPORT HOURLY DATA</h3>
          <button type="button" class="close pull-right" aria-label="Close" (click)="bsModalRef.hide()">
            <span aria-hidden="true">&times;</span>
          </button>      
        </div>
         -->

      <div class="modal-header">
        <h4 class="modal-title pull-left">{{ lang?.uploadCertificate }}</h4>
        <button type="button" class="close pull-right" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>


      <div class="modal-body column_export">
        <div class="row">
          <form>
            <input type="file" class="filestyle" id="file" name='file' data-buttonText="Choose file"
              (change)="onPhotoPickerChange($event)">
            <font style="vertical-align: inherit;">
            </font>
          </form>
        </div>
      </div>

      <div class="modal-footer">
        <!-- <div id="datatableExportBtn2" class="export_dynamic_btn">
          </div> -->
        <button type="button" class="btn btn-primary" (click)="onclick()">{{ lang?.save }}</button>
        <!-- <button class="btn btn-warning" data-dismiss="modal">Close</button>-->
        <button type="button" class="btn btn-warning" data-dismiss="modal">{{ lang?.close }}</button>

      </div>
    </div>
  </div>
</div>

<div class="modal splash fade" id="datatableExport2" tabindex="-1" role="dialog" aria-hidden="true">

  <div class="modal-dialog">
    <div class="modal-content">

      <div class="modal-header">
        <h3 class="modal-title custom-font">Select Columns</h3>
      </div>

      <div class="modal-body column_export">
        <div class="row select-alls">
          <label class="checkbox checkbox-custom-alt checkbox-custom-sm"> <input type="checkbox"
              (change)="export2_select_deselect_all($event)"><i></i> Select All </label>
        </div>
        <div class="row flexs">

          <div class="active-left">
            <h2>Active Columns</h2>

            <div class="row" *ngFor="let option of datatableCols2">
              <label class="checkbox checkbox-custom-alt checkbox-custom-sm">
                <input type="checkbox" value="{{option.id}}" [checked]="option.isSelected" class="col_select1"
                  (change)="export2_select_deselect($event)"><i></i> {{option.value}}
              </label>
            </div>

          </div>

        </div>

      </div>

      <div class="modal-footer">
        <div id="datatableExportBtn2" class="export_dynamic_btn">
        </div>
        <button class="btn btn-warning" data-dismiss="modal">Close</button>
      </div>

    </div>
  </div>
</div>


<div class="modal splash fade" id="datatableExport3" tabindex="-1" role="dialog" aria-hidden="true">

  <div class="modal-dialog">
    <div class="modal-content">

      <div class="modal-header">
        <h3 class="modal-title custom-font">Select Columns</h3>
      </div>

      <div class="modal-body column_export">
        <div class="row select-alls">
          <label class="checkbox checkbox-custom-alt checkbox-custom-sm"> <input type="checkbox"
              (change)="export3_select_deselect_all($event)"><i></i> Select All </label>
        </div>
        <div class="row flexs">

          <div class="active-left">
            <h2>Active Columns</h2>

            <div class="row" *ngFor="let option of datatableCols3">
              <label class="checkbox checkbox-custom-alt checkbox-custom-sm">
                <input type="checkbox" value="{{option.id}}" [checked]="option.isSelected" class="col_select1"
                  (change)="export3_select_deselect_all($event)"><i></i> {{option.value}}
              </label>
            </div>

          </div>

        </div>

      </div>

      <div class="modal-footer">
        <div id="datatableExportBtn3" class="export_dynamic_btn">
        </div>
        <button class="btn btn-warning" data-dismiss="modal">Close</button>
      </div>

    </div>
  </div>
</div>

<div class="modal splash fade" id="datatableExport4" tabindex="-1" role="dialog" aria-hidden="true">

  <div class="modal-dialog">
    <div class="modal-content">

      <div class="modal-header">
        <h3 class="modal-title custom-font">Select Columns</h3>
      </div>

      <div class="modal-body column_export">
        <div class="row select-alls">
          <label class="checkbox checkbox-custom-alt checkbox-custom-sm"> <input type="checkbox"
              (change)="export4_select_deselect_all($event)"><i></i> Select All </label>
        </div>
        <div class="row flexs">

          <div class="active-left">
            <h2>Active Columns</h2>

            <div class="row" *ngFor="let option of datatableCols4">
              <label class="checkbox checkbox-custom-alt checkbox-custom-sm">
                <input type="checkbox" value="{{option.id}}" [checked]="option.isSelected" class="col_select1"
                  (change)="export4_select_deselect_all($event)"><i></i> {{option.value}}
              </label>
            </div>

          </div>

        </div>

      </div>

      <div class="modal-footer">
        <div id="datatableExportBtn4" class="export_dynamic_btn">
        </div>
        <button class="btn btn-warning" data-dismiss="modal">Close</button>
      </div>

    </div>
  </div>
</div>



<div class="modal splash fade" id="datatableExport5" tabindex="-1" role="dialog" aria-hidden="true">

  <div class="modal-dialog">
    <div class="modal-content">

      <div class="modal-header">
        <h3 class="modal-title custom-font">Select Columns</h3>
      </div>

      <div class="modal-body column_export">
        <div class="row select-alls">
          <label class="checkbox checkbox-custom-alt checkbox-custom-sm"> <input type="checkbox"
              (change)="export5_select_deselect_all($event)"><i></i> Select All </label>
        </div>
        <div class="row flexs">

          <div class="active-left">
            <h2>Active Columns</h2>

            <div class="row" *ngFor="let option of datatableCols5">
              <label class="checkbox checkbox-custom-alt checkbox-custom-sm">
                <input type="checkbox" value="{{option.id}}" [checked]="option.isSelected" class="col_select1"
                  (change)="export5_select_deselect_all($event)"><i></i> {{option.value}}
              </label>
            </div>

          </div>

        </div>

      </div>

      <div class="modal-footer">
        <div id="datatableExportBtn5" class="export_dynamic_btn">
        </div>
        <button class="btn btn-warning" data-dismiss="modal">Close</button>
      </div>

    </div>
  </div>
</div>



<div class="modal splash fade" id="datatableExport6" tabindex="-1" role="dialog" aria-hidden="true">

  <div class="modal-dialog">
    <div class="modal-content">

      <div class="modal-header">
        <h3 class="modal-title custom-font">Select Columns</h3>
      </div>

      <div class="modal-body column_export">
        <div class="row select-alls">
          <label class="checkbox checkbox-custom-alt checkbox-custom-sm"> <input type="checkbox"
              (change)="export6_select_deselect_all($event)"><i></i> Select All </label>
        </div>
        <div class="row flexs">

          <div class="active-left">
            <h2>Active Columns</h2>

            <div class="row" *ngFor="let option of datatableCols6">
              <label class="checkbox checkbox-custom-alt checkbox-custom-sm">
                <input type="checkbox" value="{{option.id}}" [checked]="option.isSelected" class="col_select1"
                  (change)="export6_select_deselect_all($event)"><i></i> {{option.value}}
              </label>
            </div>

          </div>

        </div>

      </div>

      <div class="modal-footer">
        <div id="datatableExportBtn6" class="export_dynamic_btn">
        </div>
        <button class="btn btn-warning" data-dismiss="modal">Close</button>
      </div>

    </div>
  </div>
</div>